<template>
    <div class="service-entry">
      <div @click="homeList(3)">
        <img src="/images/home/bag-entry.png" alt="" />
      </div>
      <div @click="homeList(4)">
        <img src="/images/home/shoes-entry.png" alt="" />
      </div>
      <div @click="homeList(5)">
        <img src="/images/home/clothes-entry.png" alt="" />
      </div>
      <div @click="homeList(6)">
        <img src="/images/home/accessories-entry.png" alt="" />
      </div>
      <div class="large" @click="homeList(7)">
        <img src="/images/home/other-entry.png" alt="" />
      </div>
    </div>
</template>

<script>
  import zhugeObj from '@/assets/js/track'
  export default {
    name: 'service-entry',
    methods: {
      //获取定位城市
      homeList(num){
        
        switch(num){
          case 3 : 
            zhugeObj.track({
              title : '首页-点击养护服务',
              content : {
                '名称' : '包包养护'
              }
            })
            this.$router.push({ name : 'serviceDetail' , query:{serviceId:45}});
            return;
          case 4 : 
            zhugeObj.track({
              title : '首页-点击养护服务',
              content : {
                '名称' : '鞋靴养护'
              }
            })
            this.$router.push({ name : 'serviceDetail' , query:{serviceId:46}});
            return;
          case 5 : 
            zhugeObj.track({
              title : '首页-点击养护服务',
              content : {
                '名称' : '衣裤养护'
              }
            })
            this.$router.push({ name : 'serviceDetail' , query:{serviceId:47}});
            return;
          case 6 : 
            zhugeObj.track({
              title : '首页-点击养护服务',
              content : {
                '名称' : '配饰养护'
              }
            })
            this.$router.push({ name : 'serviceDetail' , query:{serviceId:48}});
            return;
          case 7 : 
            zhugeObj.track({
              title : '首页-点击养护服务',
              content : {
                '名称' : '其他养护'
              }
            })
            this.$router.push({ name: 'homeListNew',query:{actionTab:3}})
            return;
        }
      }
    },
  }
</script>

<style scoped lang="scss">
  .service-entry{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    &>div{
      width: 340px;
      height: 220px;
      background: rgba(255,255,255,1);
      box-shadow: 0px 2px 20px 0px rgba(0,0,0,0.1);
      border-radius: 6px;
      margin-bottom: 10px;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      &.large{
        width: 690px;
        height: 220px;
        background: rgba(255,255,255,1);
        box-shadow: 0px 2px 20px 0px rgba(0,0,0,0.1);
        border-radius: 6px;
      }
    }
  }
</style>
